import { useLocalization } from '@client/internationalization';
import { makeStyles } from '@material-ui/core';
import { Body } from '@minna-technologies/minna-ui/components/Typography/Body';
import type { FC } from 'react';
import React from 'react';

const useStyles = makeStyles({
  sectionMargin: {
    margin: '0 16px',
  },
});

interface Props {
  cancelledAt: string;
}

export const ConfirmedByUserContent: FC<Props> = ({ cancelledAt }) => {
  const classes = useStyles();
  const { localizeMessage, localizeDate } = useLocalization('cancel/CancellationOutcome');

  return (
    <div className={classes.sectionMargin}>
      <Body>
        {localizeMessage('ConfirmedByUserDescription', {
          date: localizeDate(cancelledAt),
        })}
      </Body>
    </div>
  );
};
